// src/pages/AboutUs.js
import React from 'react';
import './AboutUs.css';

// Import your actual images here once you have them.
// Example:
import schoolImage from '../assets/vssschoolbuilding.jpg';
import workshopImage from '../assets/vocationaltraining.jpeg';
import girlsSmilingImage from '../assets/empoweredlives.jpeg';

function AboutUs() {
  return (
    <div className="about-us-page">
      <div className="container">

        {/* --- Intro & History Section --- */}
        <section className="about-intro-section">
          <h1 className="about-heading">About Us <br/><span style={{color: "#f71391"}}>Vishwambhar Shikshan Sanstha (VSS)</span>  </h1>
          <p className="intro-paragraph">
            In <b>2006</b>, Vishwambhar Shikshan Sanstha (VSS) embarked on a journey to foster the intellectual, educational, and social development of mentally challenged girl students. We established the <b>Smt. Lilatai Deshmukh Residential Special School</b> with a singular focus: to provide specialized education, training, and rehabilitation, empowering these girls to become self-dependent and self-reliant.
          </p>
          <p className="intro-paragraph">
            Currently, our residential school proudly serves <b>65 mentally challenged girls</b>, all benefiting from the special education sanctioned by the Maharashtra Government since 2006.
          </p>
          <p className="highlight-text">
            VSS remains steadfast in its commitment to rehabilitating these girls through comprehensive vocational training, ensuring they gain the skills necessary for independence. We are constantly striving to achieve this vital goal.
          </p>
        </section>

        {/* --- Image Section 1: Angled Style --- */}
        <div className="about-image-angled-wrapper">
          <img
            src={schoolImage} // Purple background for this style
            alt="VSS school building"
            className="about-angled-image"
          />
          <div className="image-caption">Learning Environment</div>
        </div>

        {/* --- Activities & Prominence Section --- */}
        <section className="activities-section">
          <h2 className="section-title">Nurturing Growth Beyond Academics</h2>
          <p>
            Celebration of various <b>festivals and birthdays</b> are an integral part of the activities at our school. These events help students spread awareness, foster social interaction, and build a strong sense of community.
          </p>
          <p>
            We also regularly organize visits by <b>prominent and learned individuals</b> from Nagpur and beyond, providing valuable exposure and inspiration to our students.
          </p>
        </section>

        {/* --- Managed Initiatives Section --- */}
        <section className="managed-initiatives-section">
          <h2 className="section-title">Our Key Initiatives</h2>
          <p className="initiatives-intro">Vishwambhar Shikshan Sanstha proudly manages and runs the following:</p>
          <div className="initiative-cards-grid">
            <div className="initiative-card">
              <h3>1. Smt. Lilatai Deshmukh Special School</h3>
              <p>A residential special school providing education, training, and rehabilitation for mentally challenged girls.</p>
            </div>
            <div className="initiative-card">
              <h3>2. Indutai Dhoble Workshop & Rehabilitation Centre</h3>
              <p>A dedicated center for vocational training, helping girls gain practical skills for self-reliance.</p>
             {/* REMOVE THE EMPTY <p> TAG HERE */}
            </div>
            <div className="initiative-card">
              <h3>Future Endeavors</h3>
              <p>Our long-term vision includes establishing a comprehensive <b>School, Workshop, Rehab Center & Residential Center</b> for Mentally Handicapped Girls in Nagpur.</p>
            </div>
          </div>
        </section>

        {/* --- Image Section 2: Angled Style --- */}
        <div className="about-image-angled-wrapper alt-color">
          <img
            src={workshopImage} // Royal blue background for this style
            alt="Girls engaged in workshop activities"
            className="about-angled-image"
          />
          <div className="image-caption">Vocational Training</div>
        </div>

        {/* --- Inspiration & Leadership Section --- */}
        <section className="inspiration-leadership-section">
          <h2 className="section-title">Our Guiding Light</h2>
          <p className="inspiration-text">
            Our inspiration stems from <b>Late Umashankar Tiwari</b>, whose vision continues to guide our mission.
          </p>
          <p className="leadership-text">
            Vishwambhar Shikshan Sanstha is proudly run by <b>Mrs. Asha D. Tiwari</b>, who leads with dedication and compassion.
          </p>
        </section>

        {/* --- Mission & Vision Section (Reinforced) --- */}
        <section className="mission-vision-section">
          <div className="mission-box">
            <h2 className="section-title">Our Mission</h2>
            <p>
              To empower intellectually disabled girls by providing tailored educational resources, supportive programs, and a nurturing community that fosters confidence, independence, and self-advocacy. We are dedicated to creating opportunities that promote personal growth and social inclusion, enabling every girl to reach her full potential.
            </p>
          </div>
          <div className="vision-box">
            <h2 className="section-title">Our Vision</h2>
            <p>
              A world where intellectually disabled girls are recognized, valued, and empowered to live fulfilling lives. We envision a society where all girls have equal access to opportunities, support, and respect, enabling them to thrive as confident individuals and active participants in their communities.
            </p>
          </div>
        </section>

        {/* --- Image Section 3: Angled Style --- */}
        <div className="about-image-angled-wrapper">
          <img
            src={girlsSmilingImage} // Slate blue background for this style
            alt="Girls smiling and happy"
            className="about-angled-image"
          />
          <div className="image-caption">Empowered Lives</div>
        </div>

        {/* --- The VSS Difference Section --- */}
        <section className="VSS-difference-section">
          <h2 className="section-title">The VSS Difference</h2>
          <p className="difference-paragraph">
            VSS significantly enhances the lives of special girls, providing a unique environment where <b>love, smiles, and care know no end</b>. We are committed to transforming them into better citizens and productive members of our society.
          </p>
          <p className="difference-paragraph">
            Safeguarding their welfare is the mutual responsibility of a progressive and democratic society, in which these Special Girls have a right to be an integral part.
          </p>
        </section>

      </div> {/* End .container */}
    </div>
  );
}

export default AboutUs;